import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { queryKeys } from "../../offline/queryKeys";
import {
  fetchAttendanceSubmissions,
  fetchMarksSubmissions,
  fetchSchoolNotices,
} from "../../offline/teacherApi";
import { getSchoolIdForUser } from "../../utils/userContext";
import { useTeacherTeaching } from "../../hooks/useTeacherTeaching";

/**
 * Prefetch teacher data into TanStack Query + IndexedDB when class context is known.
 */
export default function TeacherOfflineBootstrap() {
  const queryClient = useQueryClient();
  const { currentUser } = useSelector((s) => s.user);
  const teacherId = currentUser?._id || currentUser?.id;
  const schoolId = getSchoolIdForUser(currentUser);
  const { activeClassId: classId } = useTeacherTeaching();

  useEffect(() => {
    if (!teacherId) return;

    queryClient.prefetchQuery({
      queryKey: queryKeys.attendanceSubmissions(teacherId),
      queryFn: () => fetchAttendanceSubmissions(teacherId),
    });
    queryClient.prefetchQuery({
      queryKey: queryKeys.marksSubmissions(teacherId),
      queryFn: () => fetchMarksSubmissions(teacherId),
    });
  }, [teacherId, queryClient]);

  useEffect(() => {
    if (!schoolId) return;
    queryClient.prefetchQuery({
      queryKey: queryKeys.schoolNotices(schoolId),
      queryFn: () => fetchSchoolNotices(schoolId),
    });
  }, [schoolId, queryClient]);

  useEffect(() => {
    if (!classId) return;
    queryClient.prefetchQuery({
      queryKey: queryKeys.classStudents(classId),
      queryFn: async () => {
        const { fetchClassStudents } = await import("../../offline/teacherApi");
        return fetchClassStudents(classId);
      },
    });
  }, [classId, queryClient]);

  return null;
}
